import React from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_CODES } from '@global/types/types';
import { formatIsbn } from '@global/utils/orderUtils';
import { dateFormatterShort } from '@global/utils/date';
import { OrderItemType } from '@global/utils/orderUtils';
import * as Constants from '@global/App/constants/constants';
import { ButtonCTA } from '@global/components/UI Elements/ButtonCTA';
import '@global/components/RestrictedCountryModal/style.scss';
import { SiteConfig } from '@src/global/utils/SiteConfig';

interface IProps {
  customData?: OrderItemType[];
  handleClose?: () => void;
  type: 'shipping' | 'billing';
}

export const RestrictedCountryModal: React.FC<IProps> = ({
  handleClose,
  customData,
  type,
}) => {
  const { t, i18n } = useTranslation('', {
    keyPrefix: 'activeForm.restrictedCountry.' + type,
  });
  const locale = i18n.language as LOCALE_CODES;

  const backToCart = () => {
    const { isAigateway } = SiteConfig.getConfig();
    if (isAigateway) {
      window.location.href = window.location.href.replace(
        Constants.CHECKOUT_PATH,
        Constants.CART_PATH
      );
      return;
    }
    window.location.href = SiteConfig.buildRedirectUrl(
      Constants.CART_CHECKOUT_BASE_URL,
      Constants.CART_PATH
    );
  };

  return (
    <>
      <h3>{t('title')}</h3>
      <p className="restricted-modal__description">{t('info')}</p>
      <p className="restricted-modal__not-available">{t('notAvailable')}</p>
      <div className="restricted-modal__products">
        {customData.map((p) => (
          <div key={p.uid} className="restricted-product">
            <div className="restricted-product__img">
              <img src={p.imageUrl} />
            </div>
            <div>
              <h3>{p.maName}</h3>
              <p className="restricted-product__authors">
                {p.authors.join(', ')}
              </p>
              <p className="restricted-product__info">
                {p.isbn13 && (
                  <span>
                    {t('isbn')}
                    {formatIsbn(p.isbn13)}
                  </span>
                )}
                {p.publicationDate && (
                  <span>{dateFormatterShort(p.publicationDate, locale)}</span>
                )}
                {p.numberOfPages && <span>{`${p.numberOfPages} Pages`}</span>}
              </p>
              <p className="restricted-product__type">{p.category}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="restricted-modal__buttons">
        <ButtonCTA
          variant="secondary"
          className="restricted-modal__back-btn"
          onClick={backToCart}
        >
          {t('backToCart')}
        </ButtonCTA>
        <ButtonCTA
          variant="primary"
          className="restricted-modal__edit-btn"
          onClick={handleClose}
        >
          {t('editPayment')}
        </ButtonCTA>
      </div>
    </>
  );
};
